import Draad_Toggle from './toggle';
import Draad_Focus_Trap from './focusTrap';

`use strict`;

class Translate {

    constructor(domNode) {

        this.TranslateElement = domNode;

        if (!document.getElementById('google-translate-script')) {
            const script = document.createElement('script');
            script.src = 'https://translate.google.com/translate_a/element.js';
            script.id = 'google-translate-script';
            script.async = true;
            document.body.appendChild(script);
        }

        this.waitForGoogleTranslate();

    }

    waitForGoogleTranslate() {

        if (typeof google === 'undefined') {

            setTimeout(() => {
                this.waitForGoogleTranslate();
            }, 100);

        } else {

            if (typeof google.translate === 'undefined') {
                setTimeout(() => {
                    this.waitForGoogleTranslate();
                }, 100);
            } else {

                if (typeof google.translate.TranslateElement === 'undefined') {
                    setTimeout(() => {
                        this.waitForGoogleTranslate();
                    }, 100);
                } else {
                    this.googleTranslateElementInit();
                }

            }
        }

    }

    googleTranslateElementInit() {

        const lang = document.documentElement.lang.split('-')[0];

        new google.translate.TranslateElement(
            {
                pageLanguage: lang,
            },
            this.TranslateElement
        );

    }

}

(function () {

    document.addEventListener('DOMContentLoaded', () => {

        const toggles = [];
        const traps = [];

        const translateToggles = document.querySelectorAll('.translate__toggle');
        if (!translateToggles) {
            return;
        }

        translateToggles.forEach((toggle, key) => {


            const mq = window.matchMedia('(min-width: ' + window.breakpoint + 'px)');
            if (mq.matches) {

                toggles[key] = new Draad_Toggle(toggle);

                traps[key] = new Draad_Focus_Trap(toggle.parentNode);

                toggle.addEventListener('DraadToggleOpen', () => {
                    traps[key].active = true;
                });

                toggle.addEventListener('DraadToggleClose', () => {
                    traps[key].active = false;
                });

            }

        });

        const translate = document.getElementById('google_translate_element');
        if (!translate) {
            return;
        }

        new Translate(translate);

    });

})();